import { useEffect, useState } from "react";
import {
    MenuOutlined,
    CloseOutlined,
    UserOutlined,
    LogoutOutlined,
    DashboardOutlined,
    AppstoreAddOutlined,
    DeploymentUnitOutlined,
    FileSearchOutlined,
    ProfileOutlined,
    FileDoneOutlined,
    ReconciliationFilled,
    MoreOutlined,
    FileFilled,
    DownOutlined,
    ScanOutlined,
    UsergroupAddOutlined,
    BarsOutlined,
    RocketOutlined,
    StarOutlined,
    DollarOutlined,
    MessageOutlined,
    HomeFilled,
    MailOutlined,
    FileTextOutlined,
    BarChartOutlined,
    PieChartOutlined,
    LineChartOutlined,
    DatabaseFilled
} from "@ant-design/icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "@/assets/inspections1.png"

import { useAuth } from "@/hooks/useAuth";
import userService from "@/services/user.service";
import { useDispatch, useSelector } from "react-redux";
import { Select, Typography } from "antd";
import { setSelectedShipId } from "@/stores/slice/shipSlice";
import ownerService from "@/services/owner.service";
import InspectionBtn from "./InspectionBtn";
import adminService from "@/services/admin.service";
import { setSubscription } from "@/stores/slice/authSlice";


// Landing page navigation items
const landingNavItems = [
    { label: "Home", anchor: "hero", icon: <HomeFilled /> },
    { label: "Features", anchor: "features", icon: <RocketOutlined /> },
    { label: "Testimonials", anchor: "testimonials", icon: <StarOutlined /> },
    { label: "Pricing", anchor: "pricing", icon: <DollarOutlined /> },
    { label: "Contact", anchor: "contact", icon: <MessageOutlined /> }
];

export default function Header() {
    const userdata = useSelector((state) => state.auth);
    const getuserid = userdata?.user?.user_id
    const [isOpen, setIsOpen] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [showMoreMenu, setShowMoreMenu] = useState(false);
    const [showShipSelector, setShowShipSelector] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeSubmenu, setActiveSubmenu] = useState(null); // For desktop submenu
    const [mobileReportsMenuOpen, setMobileReportsMenuOpen] = useState(false); // For mobile submenu
    const { auth, currentUser, logout, isAuthenticated } = useAuth();
    const { role, user } = auth || {};
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const selectedShipId = useSelector((state) => state.ship.selectedShipId);
    const { subscription } = useSelector(state => state.auth)

    const [ships, setShips] = useState([]);
    // Smooth scroll function for anchor navigation
    const scrollToSection = (anchor) => {
        const element = document.getElementById(anchor);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
        setIsMobileMenuOpen(false);
    };


    const getReportsSubmenu = (role) => {
        const basePrefix = role === "ADMIN" ? "/admin" : role === "OWNER" ? "/manager" : "/user";
        return (subscription && subscription?.reports?.length) ? subscription?.reports?.map(x => (
            {
                label: x?.label, path: `${basePrefix}/reports/${x?.value}`

            })) : []
    };

    const getNavigationConfig = (role) => {
        const navigationConfigs = {
            ADMIN: [
                { label: "Dashboard", path: "/admin/dashboard", icon: <DashboardOutlined /> },
                { label: "ModuleBuilder", path: "/admin/module-builder", icon: <AppstoreAddOutlined /> },
                {
                    label: "Reports",
                    path: "/admin/report-manager",
                    icon: <AppstoreAddOutlined />,
                },
                { label: "Recommendation", path: "/admin/recommdation", icon: <ReconciliationFilled /> },
                { label: "Feedbacks", path: "/admin/feedbacks", icon: <FileFilled /> },
                { label: "Subscription", path: "/admin/subscription", icon: <BarsOutlined /> },
            ],

            USER: [
                { label: "Vessels", path: "/user/dashboard", icon: <DashboardOutlined /> },
                { label: "Inspections", path: "/user/inspections", icon: <FileDoneOutlined /> },
                {
                    label: "Reports",
                    icon: <FileSearchOutlined />,
                    hasSubmenu: true,
                    submenu: getReportsSubmenu("USER")
                },
                { label: "Data Tables", path: "/user/inspectionlist", icon: <DatabaseFilled /> },
            ],
            OWNER: [
                { label: "Dashboard", path: "/manager/dashboard", icon: <DashboardOutlined /> },
                { label: "Inspections", path: "/manager/inspections", icon: <FileDoneOutlined /> },
                {
                    label: "Reports",
                    icon: <FileSearchOutlined />,
                    hasSubmenu: true,
                    submenu: getReportsSubmenu("OWNER")
                },
                { label: "Data Tables", path: "/manager/inspectionlist", icon: <DatabaseFilled /> },
            ]
        };
        return navigationConfigs[role] || [];
    };

    const syncLocalSubscription = async () => {
        const localSubpayload = {
            no_of_reports: subscription?.no_of_reports,
            no_of_inspection_reports: subscription?.no_of_inspection_reports,

            name: subscription.name,
            max_users: subscription.max_users,
            max_ships: subscription.max_ships,
            max_events: subscription.max_events
        }
        await adminService.synclocalSubscription(localSubpayload);
    }
    const updateSubscription = async () => {
        const updateSubscription = await adminService.syncSubscription(subscription?.name);
        console.log("updateSubscription",updateSubscription)
        let updateSubscripe = { ...subscription }
        updateSubscripe["reports"] = updateSubscription?.data.reports;
        updateSubscripe["events"] = updateSubscription?.data.events
        updateSubscripe["cloud_save"] = updateSubscription?.data.cloud_save

        if (updateSubscription?.data.no_of_reports) {
            updateSubscripe["no_of_reports"] = updateSubscription?.data.no_of_reports;
            updateSubscripe["no_of_inspection_reports"] = updateSubscription?.data.no_of_inspection_reports;
        }

        dispatch(setSubscription(updateSubscripe));
        return
    }

    useEffect(() => {
        if (role === "USER" || role === "OWNER") {
            syncLocalSubscription()
            updateSubscription()
        }

    }, [role])

    useEffect(() => {
        const getuserShips = async () => {
            const getshipslist = await userService.getuserShips(getuserid);
            setShips(getshipslist?.ships?.length ? getshipslist?.ships : [])
        }
        const getownerShips = async () => {
            const response = await ownerService.getownerships();
            if (response.success) {
                setShips(response.data || []);
            } else {
                setShips([]);
            }
        }
        if (role === "USER") {
            getuserShips()
        }
        else if (role === "OWNER") {
            getownerShips()
        }
    }, [getuserid, role])

    const handleShipSelect = (ship) => {
        dispatch(setSelectedShipId(ship));
        setShowShipSelector(false);
    };


    useEffect(() => {
        if (ships.length > 0 && !selectedShipId) {
            setSelectedShipId(ships[0].imo_number);
            handleShipSelect(ships[0]?.imo_number);
        }
    }, [ships, selectedShipId]);

    const currentRole = role;
    const userData = currentUser || user;
    const navigationItems = getNavigationConfig(currentRole);

    const handleLogout = async () => {
        try {
            await logout();
            window.location.reload();
            navigate("/login");
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };

    const isActivePath = (path) => location.pathname === path;

    // Check if current path is within reports submenu
    const isActiveSubmenuPath = (submenu) => {
        return submenu?.some(item => location.pathname.startsWith(item.path));
    };

    const authPages = ["/login", "/register", "/forgetpassword"];

    // Show landing page header for non-authenticated users or on home page
    if (!isAuthenticated || location.pathname === "/") {
        return (
            <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm border-b border-gray-100">
                <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-16">
                        <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
                                <div className="flex items-center">
                                    <img
                                        src={Logo}
                                        alt="Company Logo"
                                        className="h-12 w-15 rounded object-contain"
                                    />
                                    <span className="text-[20px] font-extrabold tracking-tight bg-gradient-to-r from-[#0087af] to-[#00ae68]  bg-clip-text text-transparent">
                                        SpotFlash
                                    </span>
                                </div>

                            </div>
                        </div>

                        {/* Desktop Navigation */}
                        <nav className="hidden lg:flex items-center space-x-1">
                            {landingNavItems.map((item, index) => (
                                <button
                                    key={index}
                                    onClick={() => scrollToSection(item.anchor)}
                                    className="flex items-center space-x-2 font-medium text-sm px-4 py-2 rounded-lg transition-all duration-200 text-gray-700 hover:text-[#289E80] hover:bg-emerald-50"
                                >
                                    {item.icon}
                                    <span>{item.label}</span>
                                </button>
                            ))}
                        </nav>

                        {/* Desktop Auth Buttons */}
                        <div className="hidden lg:flex items-center space-x-3">
                            <Link
                                to="/login"
                                className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-[#289E80] transition-colors"
                            >
                                Sign In
                            </Link>
                            <InspectionBtn
                                onClick={() => navigate("/verify")}
                            >
                                Get Started
                            </InspectionBtn>
                        </div>

                        {/* Mobile Menu Button */}
                        <button
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            className="lg:hidden p-2 text-gray-700 hover:text-[#289E80] transition-colors"
                        >
                            {isMobileMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
                        </button>
                    </div>

                    {/* Mobile Menu */}
                    {isMobileMenuOpen && (
                        <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-100 shadow-lg">
                            <div className="px-4 py-4 space-y-2">
                                {landingNavItems.map((item, index) => (
                                    <button
                                        key={index}
                                        onClick={() => scrollToSection(item.anchor)}
                                        className="flex items-center space-x-3 w-full text-left px-3 py-3 text-gray-700 hover:text-[#289E80] hover:bg-emerald-50 rounded-lg transition-colors"
                                    >
                                        {item.icon}
                                        <span className="font-medium">{item.label}</span>
                                    </button>
                                ))}
                                <div className="pt-4 border-t border-gray-100 flex flex-col space-y-2">
                                    <Link
                                        to="/login"
                                        className="px-4 py-3 text-center text-gray-700 hover:text-[#289E80] font-medium rounded-lg hover:bg-emerald-50 transition-colors"
                                        onClick={() => setIsMobileMenuOpen(false)}
                                    >
                                        Sign In
                                    </Link>
                                    <Link
                                        to="/verify"

                                        className="px-4 py-3 text-center text-white bg-[#289E80] rounded-lg hover:bg-[#1f7a63] font-medium transition-colors"
                                        onClick={() => {
                                            navigate("/verify")
                                            setIsMobileMenuOpen(false)
                                        }
                                        }>
                                        Get Started
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </header >
        );
    }

    // Hide header for auth pages
    if (authPages.includes(location.pathname)) return null;

    // Get selected ship details
    const selectedShip = ships.find(ship => ship.id === selectedShipId);

    // For mobile bottom nav
    const mobileNavItems = currentRole === "USER"
        ? [
            { label: "Vessels", path: "/user/dashboard", icon: <DashboardOutlined /> },
            { label: "Inspections", path: "/user/inspections", icon: <FileDoneOutlined /> },
            { label: "Reports", path: "/user/reports", icon: <FileSearchOutlined /> },
            { label: "Data Tables", path: "/user/reports", icon: <DatabaseFilled /> },

        ]
        : navigationItems.slice(0, 4);

    const moreItems = navigationItems.slice(4);
    const moreNavItems = navigationItems.slice(4);

    return (
        <>
            {/* Desktop Header with Submenu Support */}
            <header
                className="hidden lg:block fixed top-0 left-0 right-0 z-50 bg-white border-b-3 border-yellow-400 
                "
                style={{ boxShadow: "   rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px" }}
            >

                <div className="max-w-screen-3xl mx-auto px-3  ">
                    <div className="flex justify-between items-center h-14">
                        {/* Logo Section */}
                        <div className="flex   items-center space-x-3">
                            <div className="flex items-center">
                                <img
                                    src={Logo}
                                    alt="Company Logo"
                                    className="h-12 w-15 rounded object-contain"
                                />
                                <span className="text-[20px] font-extrabold tracking-tight bg-gradient-to-r from-[#0087af] to-[#00ae68] bg-clip-text text-transparent">
                                    SpotFlash
                                </span>
                            </div>
                            {/* Desktop - Show full branding */}
                            <div className="flex flex-col leading-tight ms-2">
                                <span className="text-xs font-bold text-[#0087af]">
                                    {role == "OWNER" ? "Manager" : role === "USER" ? "User" : "Admin"}
                                </span>
                                <span className="text-center text-[10px] font-bold text-gray-400">
                                    V2.1
                                </span>
                            </div>

                            <nav className="flex items-center space-x-2 ml-4">
                                {navigationItems.map((item, index) => (
                                    <div key={index} className="relative">
                                        {item.hasSubmenu ? (
                                            <>
                                                <button
                                                    onMouseEnter={() => setActiveSubmenu(index)}
                                                    onMouseLeave={() => setActiveSubmenu(null)}
                                                    onClick={() => navigate(item.path)}
                                                    className={`flex items-center space-x-2 text-sm font-medium px-2 py-1 rounded-xl transition-all duration-200
                                                   ${isActivePath(item.path) || isActiveSubmenuPath(item.submenu)
                                                            ? "bg-gradient-to-r from-[#0087af] to-[#00ae68] text-white shadow-sm"
                                                            : "text-gray-700 hover:bg-gray-100"
                                                        }`}
                                                >
                                                    {item.icon}
                                                    <span>{item.label}</span>
                                                    <DownOutlined className="text-xs" />
                                                </button>

                                                {/* Desktop Submenu Dropdown */}
                                                {activeSubmenu === index && (
                                                    <div
                                                        className="absolute top-6 left-0 mt-1 w-56 bg-white rounded-lg shadow-lg border border-gray-100 py-2 z-50"
                                                        onMouseEnter={() => setActiveSubmenu(index)}
                                                        onMouseLeave={() => setActiveSubmenu(null)}
                                                    >
                                                        {item.submenu.map((subItem, subIndex) => (
                                                            <Link
                                                                key={subIndex}
                                                                to={subItem.path}
                                                                className={`flex items-center space-x-3 px-4 py-2 text-sm transition-colors hover:bg-gray-50
                                                                    ${isActivePath(subItem.path)
                                                                        ? "text-[#0087af] bg-blue-50"
                                                                        : "text-gray-700"
                                                                    }`}
                                                            >
                                                                {subItem.icon}
                                                                <span>{subItem.label}</span>
                                                            </Link>
                                                        ))}
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <Link
                                                to={item.path}
                                                className={`flex items-center space-x-2 text-sm font-medium px-2 py-1 rounded-xl transition-all duration-200
                                               ${isActivePath(item.path)
                                                        ? "bg-gradient-to-r from-[#0087af] to-[#00ae68] text-white shadow-sm"
                                                        : "text-gray-700 hover:bg-gray-100"
                                                    }`}
                                            >
                                                {item.icon}
                                                <span>{item.label}</span>
                                            </Link>
                                        )}
                                    </div>
                                ))}
                            </nav>

                        </div>
                        <div className="flex items-center space-x-4">
                            {(currentRole === "USER" || currentRole === "OWNER") && (
                                <Select className="right-5 w-60"
                                    options={ships?.length ? ships?.map(x => ({
                                        label: `🚢 ${x.name} (${x.vessel_type})`,
                                        value: x?.imo_number
                                    })) : []}
                                    value={selectedShipId || ''}
                                    onChange={(e) => handleShipSelect(e)}
                                >
                                </Select>
                            )}

                            <div className="relative">
                                <InspectionBtn size="small"
                                    type="primary"
                                    onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                                    className="flex items-center text-sm rounded-lg bg-gray-50   hover:bg-gray-100 transition-colors"
                                >
                                    <UserOutlined className="me-3" />
                                    <span className="text-white  font-medium font-12">
                                        {user?.username || "Elan"}
                                    </span>
                                    <DownOutlined className={`text-xs ms-2 transform transition-transform ${isUserMenuOpen ? "rotate-180" : ""}`} />
                                </InspectionBtn>

                                {isUserMenuOpen && (
                                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg py-2 z-50 border border-gray-100">

                                        <div className="flex mb-2">
                                            <MailOutlined className="ms-4 text-gray-300" size={18} />
                                            <Typography.Text className=" ms-2 text-gray-300 text-xs ">      {user?.email}</Typography.Text>
                                        </div>
                                        {role === "USER" && (
                                            <Link
                                                to="/user/profile"
                                                className="flex items-center space-x-2 px-2 py-3 text-sm text-gray-700 hover:bg-gray-100 rounded-lg mx-2"
                                                onClick={() => setIsUserMenuOpen(false)}
                                            >
                                                <UserOutlined />

                                                <span>Profile</span>
                                            </Link>
                                        )}
                                        <button
                                            onClick={() => {
                                                setIsUserMenuOpen(false);
                                                handleLogout();
                                            }}
                                            className="flex items-center space-x-2 w-full text-left px-2 py-1 text-sm text-red-600 hover:bg-red-50 rounded-lg mx-2"
                                        >
                                            <LogoutOutlined />
                                            <span>Logout</span>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Mobile Bottom Navigation Only */}
            <div className="lg:hidden">
                {/* Mobile Bottom Navigation */}
                <nav className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-[#0087af] to-[#00ae68] border-t-4  !border-yellow-400">
                    <div className="flex items-center justify-between px-4  ">
                        {/* First Navigation Item */}
                        {mobileNavItems.slice(0, 1).map((item, index) => {
                            const isActive = isActivePath(item.path);
                            return (
                                <Link
                                    key={index}
                                    to={item.path}
                                    className={`flex flex-col items-center space-y-0 py-2 px-3 rounded-xl transition-all duration-300 ${isActive ? "text-yellow-400 " : " text-white "}`}
                                >
                                    <div className={`text-lg transition-all duration-300 ${isActive ? "text-yellow-400 scale-110" : ""}`}>
                                        {item.icon}
                                    </div>
                                    <span className="text-xs font-medium">
                                        {item.label.split(' ')[0]}
                                    </span>
                                </Link>
                            );
                        })}

                        {/* Second Navigation Item */}
                        {mobileNavItems.slice(1, 2).map((item, index) => {
                            const isActive = isActivePath(item.path);
                            return (
                                <Link
                                    key={index + 1}
                                    to={item.path}
                                    className={`flex flex-col items-center space-y-0 py-2 px-3 rounded-xl transition-all duration-300 ${isActive ? "text-yellow-400 " : " text-white "}`}
                                >
                                    <div className={`text-lg transition-all duration-300 ${isActive ? " text-yellow-400 scale-110" : ""}`}>
                                        {item.icon}
                                    </div>
                                    <span className="text-xs font-medium">
                                        {item.label.split(' ')[0]}
                                    </span>
                                </Link>
                            );
                        })}

                        <div className="relative flex flex-col items-center">
                            {/* Ship Selector - Only for USER role */}
                            {currentRole === "USER" || currentRole === "OWNER" ? (
                                <div className="relative">
                                    {/* Professional Circular Card at Center */}
                                    <div
                                        onClick={() => setShowShipSelector(true)}
                                        className="relative bg-white rounded-full w-14 h-14 mx-auto shadow-sm border border-gray-200 hover:shadow-md hover:border-gray-300 transform hover:scale-105 transition-all duration-200 cursor-pointer"
                                    >
                                        {/* Logo Container */}
                                        <div className="absolute inset-1 bg-gray-50 rounded-full flex items-center justify-center">
                                            <img
                                                src={Logo}
                                                alt="Spot Flash Logo"
                                                className="h-14 w-14 mb-2 me-1 object-contain"
                                            />
                                        </div>

                                        {/* Professional Ship Name Badge */}
                                        <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2">
                                            <div className="bg-gradient-to-r from-[#0087af] to-[#00ae68] text-white h-5 px-2 flex items-center justify-center rounded-full shadow-sm min-w-max">
                                                <span className="text-[10px] leading-none">
                                                    {selectedShip
                                                        ? selectedShip.name.substring(0, 8) + (selectedShip.name.length > 8 ? '..' : '')
                                                        : "Ship"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Ship Selector Modal */}
                                    {showShipSelector && (
                                        <>
                                            <div
                                                className="fixed inset-0 bg-black/30 z-40"
                                                onClick={() => setShowShipSelector(false)}
                                            ></div>

                                            <div className="fixed bottom-20 left-1/2 transform -translate-x-1/2 w-72 max-w-[85vw] bg-white rounded-xl shadow-2xl border border-gray-200 z-50 overflow-hidden">
                                                <div className="p-2 bg-gray-50 border-b border-gray-200">
                                                    <div className="flex items-center justify-between">
                                                        <div className="flex items-center gap-3">

                                                            <h3 className="font-semibold text-gray-800 text-sm">Select Your Ship</h3>
                                                        </div>
                                                        <button
                                                            onClick={() => setShowShipSelector(false)}
                                                            className="w-7 h-7 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-colors"
                                                        >
                                                            <CloseOutlined className="text-xs text-gray-600" />
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="max-h-60 overflow-y-auto">
                                                    {ships.length === 0 ? (
                                                        <div className="p-4 text-center">

                                                            <p className="text-gray-500 text-sm font-medium">No ships available</p>
                                                        </div>
                                                    ) : (
                                                        ships.map((ship) => (
                                                            <button
                                                                key={ship.id}
                                                                onClick={() => handleShipSelect(ship?.imo_number)}
                                                                className={`w-full px-4 py-3 text-left hover:bg-gray-50 flex items-center gap-3 transition-colors border-b border-gray-100 last:border-b-0 ${selectedShipId === ship.id ? "bg-gray-50 border-l-3 border-l-gray-800" : ""}`}
                                                            >
                                                                <div className={`w-9 h-9 rounded-full flex items-center justify-center border ${selectedShipId === ship.id
                                                                    ? "bg-gray-800 text-white border-gray-800"
                                                                    : "bg-gray-100 text-gray-600 border-gray-200"}`}>
                                                                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                                        <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                                                                    </svg>
                                                                </div>

                                                                <div className="flex-1 min-w-0">
                                                                    <div className="font-semibold text-gray-900 text-sm truncate">
                                                                        {ship.name}
                                                                    </div>
                                                                    <div className="text-xs text-gray-500 mt-0.5">
                                                                        <span className="bg-gray-100 px-2 py-0.5 rounded text-xs mr-2">
                                                                            IMO: {ship.id}
                                                                        </span>
                                                                        <span>{ship.type}</span>
                                                                    </div>
                                                                </div>

                                                                {selectedShipId === ship.id && (
                                                                    <div className="text-gray-800">
                                                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                                        </svg>
                                                                    </div>
                                                                )}
                                                            </button>
                                                        ))
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ) : (
                                <div className="flex justify-center">
                                    <div
                                        onClick={() => setShowShipSelector(true)}
                                        className="relative bg-white rounded-full w-14 h-14 shadow-sm border border-gray-200 hover:shadow-md hover:border-gray-300 transform hover:scale-105 transition-all duration-200 cursor-pointer"
                                    >
                                        <div className="absolute inset-1 bg-gray-50 rounded-full flex items-center justify-center">
                                            <img
                                                src={Logo}
                                                alt="Spot Flash Logo"
                                                className="h-15 w-15 me-1 object-contain"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Third Navigation Item - Reports with Mobile Submenu */}
                        <div className="relative">
                            <button
                                onClick={() => setMobileReportsMenuOpen(!mobileReportsMenuOpen)}
                                className="flex flex-col items-center space-y-0 py-2 px-3 rounded-xl transition-all duration-300 text-white"
                            >

                                <div className={`text-lg transition-all duration-300 ${mobileReportsMenuOpen ? "scale-110" : ""}`}>
                                    <FileSearchOutlined />
                                </div>
                                <span className="text-xs font-medium">Reports</span>
                            </button>

                            {/* Mobile Reports Submenu */}
                            {mobileReportsMenuOpen && (
                                <>
                                    <div
                                        className="fixed inset-0 bg-black/30 z-40"
                                        onClick={() => setMobileReportsMenuOpen(false)}
                                    ></div>

                                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-4 w-56 bg-white rounded-2xl shadow-2xl border border-gray-100 py-3 z-50">
                                        <div className="px-4 py-2 border-b border-gray-100">
                                            <h3 className="font-semibold text-gray-800 text-sm flex items-center gap-2">
                                                <FileSearchOutlined className="text-[#0087af]" />
                                                Reports Menu
                                            </h3>
                                        </div>

                                        {getReportsSubmenu(currentRole).map((item, index) => (
                                            <Link
                                                key={index}
                                                to={item.path}
                                                className={`flex items-center space-x-3 px-4 py-3 text-sm transition-colors hover:bg-gray-50 ${isActivePath(item.path)
                                                    ? "text-[#0087af] bg-blue-50 border-l-3 border-l-[#0087af]"
                                                    : "text-gray-700"
                                                    }`}
                                                onClick={() => setMobileReportsMenuOpen(false)}
                                            >
                                                <div className="text-base">
                                                    {item.icon}
                                                </div>
                                                <span className="font-medium">{item.label}</span>
                                            </Link>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Profile/More Menu */}
                        <div className="relative">
                            <button
                                onClick={() => navigate("/manager/inspectionlist")}
                                className={`flex flex-col items-center space-y-0 py-2 px-3 rounded-xl transition-all duration-300  text-white`} >
                                <div className={`text-lg transition-all duration-300 `}>
                                    <UserOutlined />
                                </div>
                                <span className="text-xs font-medium">
                                    Data Tables
                                </span>
                            </button>

                            {/* User Menu Dropdown */}
                            {isUserMenuOpen && (
                                <>
                                    <div
                                        className="fixed inset-0 bg-black/20 z-40"
                                        onClick={() => setIsUserMenuOpen(false)}
                                    ></div>

                                    <div className="absolute bottom-full right-0 mb-4 w-56 bg-white rounded-2xl shadow-2xl border border-gray-100 py-3 z-50">
                                        {/* User Info Header */}
                                        <div className="px-4 py-2 border-b border-gray-100">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-10 h-10  bg-gradient-to-r from-[#0087af] to-[#00ae68]  rounded-full flex items-center justify-center">
                                                    <UserOutlined className="text-white" />
                                                </div>
                                                <div>
                                                    <div className="font-semibold text-gray-900 text-sm">
                                                        {userData?.name || "User"}
                                                    </div>
                                                    <div className="text-xs text-gray-500">
                                                        {userData?.email || "user@example.com"}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {moreNavItems.length > 0 && (
                                            <>
                                                <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                                    More Options
                                                </div>
                                                {moreNavItems.map((item, index) => (
                                                    <Link
                                                        key={index}
                                                        to={item.path}
                                                        className={`flex items-center space-x-3 px-4 py-2 text-sm transition-colors ${isActivePath(item.path)
                                                            ? "text-green-600 bg-green-50"
                                                            : "text-gray-700 hover:bg-gray-50"
                                                            }`}
                                                        onClick={() => setIsUserMenuOpen(false)}
                                                    >
                                                        <div className="text-base">
                                                            {item.icon}
                                                        </div>
                                                        <span className="font-medium">{item.label}</span>
                                                    </Link>
                                                ))}
                                                <hr className="my-2 mx-2" />
                                            </>
                                        )}


                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </nav>
            </div>
        </>
    );
}